"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const WidgetHelp_vue_1 = __importDefault(require("../components/WidgetHelp.vue"));
const PendingTasksSection_vue_1 = __importDefault(require("./PendingTasksSection.vue"));
const Dashboard_1 = __importDefault(require("../class/models/Dashboard"));
const WidgetEBecrop_vue_1 = __importDefault(require("../components/WidgetEBecrop.vue"));
let WelcomeSection = class WelcomeSection extends vue_property_decorator_1.Vue {
    get title() {
        return `${this.$trans('dashboard_single.welcome.hello')} ${this.userName}`;
    }
    get subtitle() {
        return this.$trans('dashboard_single.welcome.w_becrop');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '---' })
], WelcomeSection.prototype, "userName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new Dashboard_1.default() })
], WelcomeSection.prototype, "dataset", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], WelcomeSection.prototype, "isBmk", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], WelcomeSection.prototype, "vuedata", void 0);
WelcomeSection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            WidgetHelp: WidgetHelp_vue_1.default,
            PendingTasksSection: PendingTasksSection_vue_1.default,
            WidgetEBecrop: WidgetEBecrop_vue_1.default,
        },
    })
], WelcomeSection);
exports.default = WelcomeSection;
